import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { IFileExtend } from "../../model/IFileExtend";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class GroupGlSubmissionService {
  routePrefix = "/api/group-gl-submission";
  constructor(private http: HttpClient) { }

  getGroupPoliciesOfLoggedInHRUser(): Observable<any> {
    return this.http.get(this.routePrefix + "/get-group-policies-of-HR");
  }

  getEnrolsByGroupPolicyId(groupPolicyId: number): Observable<any> {
    return this.http.get(this.routePrefix + "/get-enrols-by-group-policy-id/" + groupPolicyId);
  }

  getClaimSubmissionDataForGL(enrolId: number): Observable<any> {
    return this.http.get(this.routePrefix + "/get-claim-submission-data-for-GL/" + enrolId);
  }

  getGLClaimDocuments(productId: number,isAuthLetter: boolean) {
    return this.http.get(`${this.routePrefix}/gl-documents/${productId}/${isAuthLetter}`);
  }

  add(data: FormData) {
    return this.http.post(`${this.routePrefix}/add`,data);
  }

  getGlClaimFormDocument(): Observable<IFileExtend> {
    return this.http.get<IFileExtend>(`${this.routePrefix}/getGlClaimFormDocument/`);
  }

  getGlClaimForm(data: any): Observable<any> {
    return this.http.post(this.routePrefix + '/getGlClaimForm', data, { responseType: 'blob' })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  getHistoricalGlNigoClaims(groupPolicyId: number): Observable<any> {
    return this.http.get(this.routePrefix + '/getHistoricalGlNigoClaims/' + groupPolicyId);
  }

  getGlGroupPoliciesForHR(policyType: number): Observable<any> {
    return this.http.get(`${this.routePrefix}/getGlGroupPoliciesForHR/${policyType}`);
  }

  getGlRequireNigoDocuments(claimEntryId: number): Observable<any> {
    return this.http.get(`${this.routePrefix}/getGlRequireNigoDocuments/${claimEntryId}`);
  }

  additionalDocumentSubmission(data): Observable<any> {
    return this.http.post(this.routePrefix + "/additionalDocumentSubmission", data);
  }
}
